import * as React from 'react';
import { forwardRef } from 'react';
import { AppBar, UserMenu, MenuItemLink, useTranslate } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import SettingsIcon from '@material-ui/icons/Settings';
import { makeStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Logo from './Logo';
import LockIcon from '@material-ui/icons/Lock';


const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
});

const CustomUserMenu = (props) => (
  <UserMenu {...props}>
    <MenuItemLink
      to="/profile"
      primaryText="My profile"
      leftIcon={<AccountCircleIcon />}
    />
    <MenuItemLink
      to="/profile/change-password"
      primaryText="Change password"
      leftIcon={<LockIcon />}
    />
  </UserMenu>
);

const CustomAppBar = (props) => {
    const classes = useStyles();
    return (
        <AppBar {...props} elevation={1} userMenu={<CustomUserMenu />}>
            <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
                id="react-admin-title"
            />
            <Logo height="40" />
            <span className={classes.spacer} />
        </AppBar>
    );
};

export default CustomAppBar;